import { render, staticRenderFns } from "./SpeechAlbums.vue?vue&type=template&id=36d7e518&scoped=true&"
import script from "./SpeechAlbums.vue?vue&type=script&lang=js&"
export * from "./SpeechAlbums.vue?vue&type=script&lang=js&"
import style0 from "./SpeechAlbums.vue?vue&type=style&index=0&id=36d7e518&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d7e518",
  null
  
)

export default component.exports